<template>
    <WrapBg title="" bgImg="myBg">
        <Crumbs title="交易限额"/>
        <el-table v-loading="loading" :data="tableList" stripe class="mb-50">
            <el-table-column prop="acctId" label="账号"></el-table-column>
            <el-table-column prop="prdCodeName" label="账户类型"></el-table-column>
            <el-table-column label="小额免密" width="100">
                <template slot-scope="scope">
                    {{scope.row.singleAmtStatus=='1'?'启用':'禁用'}}
                </template>
            </el-table-column>
            <el-table-column label="免密额度(元)" width="110">
                <template slot-scope="scope">
                    {{scope.row.singleAmt/100}}
                </template>
            </el-table-column>
            <el-table-column label="设置" width="60">
                <template slot-scope="scope">
                    <el-link @click="modify(scope.row)" type="primary" :underline="false">编辑</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="交易限额设置" :visible.sync="editVisible" width="550px">
            <el-card :class="['card', (form.prdType=='10' || form.prdType=='49')?'bg1':'bg2']" :body-style="{padding:'10px'}">
                <span :class="[(form.prdType=='10' || form.prdType=='49')?'text-primary':'text-warning']">
                    <i class="el-icon-postcard"></i>
                    <span class="ml-10">{{form.prdCodeName}}</span>
                </span>
                <span class="text-gray ml-10">{{form.acctId}}</span>
            </el-card>
            <el-divider></el-divider>
            <el-form :model="form" label-width="200px" label-position="left">
                <div class="formItemFlex mb-10">
                    <div>小额免密</div>
                    <el-switch v-model="form.singleAmtStatus" :active-value="1" :inactive-value="0"></el-switch>
                </div>
                <div class="formItemFlex">
                    <div style="flex: 1;text-align: left;">
                        <div class="text-gray">免密额度(元)</div>
                        <div class="text-gray">小额免密限额≤ 6.00元</div>
                    </div>
                    <el-input v-model="singleAmt" size="small" style="width:80px;"></el-input>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="save" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </WrapBg>
</template>

<script>
    export default {
        name: "Limit",
        data(){
            return{
                loading:false,
                tableList:[],
                editVisible:false,
                form:{},
                singleAmt:'',//免密额度
            }
        },
        created(){
            this.getAccount();
        },
        methods:{
            async getAccount(){
                this.loading = true;
                let res = await this.$unifiedApi({
                    api:this.$api.electronicAccount,
                    fn:this.getAccount,
                    params:{method:'member',devId:'WEB'},
                });
                if(!res || !res.data) return;
                let data = res.data;
                if(data.respCode === '0000'){
                    let list = [];
                    for(let item of data.objs){
                        if(item.prdType=='10' || item.prdType=='49' || item.prdType=='50' || item.prdType=='98'){
                            list.push(item);
                        }
                    }
                    this.tableList = list;
                }else{
                    this.$message.error(data.respInfo);
                }
                this.loading = false;
            },
            modify(row){
                this.form = row;
                this.singleAmt = row.singleAmt/100;
                this.editVisible = true;
            },
            async save(){
                let singleAmt = this.singleAmt;
                if(this.form.singleAmtStatus==1 && singleAmt===''){
                    return this.$message.warning('免密金额不能为空');
                }
                const loading = this.$loading({background: 'rgba(0, 0, 0, 0.3)'});
                let res = await this.$unifiedApi({
                    api: this.$api.electronicAccountEdit,
                    fn: this.save,
                    params: {
                        method: 'member', devId: 'WEB',
                        prdCode:this.form.prdCode,
                        singleAmtStatus: this.form.singleAmtStatus,
                        singleAmt: Math.round(singleAmt*100),
                    },
                    urlParams:this.form.acctId
                });
                if(!res || !res.data) return;
                let data = res.data;
                if (data.respCode === '0000') {
                    this.getAccount();
                    this.editVisible = false;
                    this.$message.success('保存成功');
                } else {
                    this.$message.error(data.respInfo);
                }
                loading.close();
            },
        }
    }
</script>

<style lang="less" scoped>
    .annotation{
        font-size:12px;
        text-align: right;
        color:#c0c4cc;
        padding:0 0 15px 15px;
    }
    .formItemFlex{
        display: flex;justify-content: space-between;align-items: center;
        padding:0 50px;
    }
    //账户
      .card{
          width:290px;
          height:90px;
          margin:0 auto;
        .balance{
            font-weight: 600;
            font-size:20px;
            margin:19px 0 6px;
        }
    }
    .card.bg1{
        background:url('../assets/accountBg1.png') no-repeat right;
    }
    .card.bg2{
        background:url('../assets/accountBg2.png') no-repeat right;
    }
</style>